import type { Branding } from '@erebus/runtime-config';

/**
 * Per-brand identity tokens. Structural tokens (typography, spacing, radii)
 * are shared across all brands via the Aura baseline and are NOT part of this type —
 * only brand identity (palette + logo + product name) varies per brand.
 */
export interface BrandTokens {
  /** Brand primary color (base 500 shade). */
  primary: string;
  /** Neutral/surface seed color. */
  surface: string;
  /** Accent color. */
  accent: string;
  /** Status: success. */
  success: string;
  /** Status: danger/error. */
  danger: string;
  /** Status: info. */
  info: string;
  /** Status: warning. */
  warning: string;
  /** Public path to the brand logo. */
  logo: string;
  /** Human-readable product name. */
  productName: string;
}

/**
 * Canonical praxes brand. Sourced from the historical Quasar/PrimeVue palette
 * (formerly apps/frontend/src/css/colors.ts).
 */
const praxes: BrandTokens = {
  primary: '#233F94',
  surface: '#7B858D',
  accent: '#BE1E2D',
  success: '#21BA45',
  danger: '#CF3F4D',
  info: '#31CCEC',
  warning: '#F2C037',
  logo: '/praxes_logo_swish.png',
  productName: 'PRAXES Connect',
};

/**
 * Brand registry keyed by the runtime-config `Branding` discriminator.
 *
 * rmi currently inherits the praxes palette — rmi has no brand kit in the
 * codebase yet. Override `primary`, `logo`, and `productName` here when real
 * rmi brand assets are supplied (tracked as a follow-up ticket).
 */
export const brands: Record<Branding, BrandTokens> = {
  praxes,
  rmi: {
    ...praxes,
    productName: 'RMI',
  },
};
